import { Icon, Icons } from "../../atoms/icon";
import * as styles from "./styles.css";
import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import { Link } from "../../atoms/link";
import Strings from "../../../utils/hardcoded.json";
export const PremiumButton = ({ isPremiumAccount, closeDrawer, }) => (React.createElement(React.Fragment, null, isPremiumAccount ? (React.createElement("div", null,
    React.createElement("div", { className: styles.separator }),
    React.createElement("div", { className: styles.premium },
        React.createElement(Icon, { type: Icons.PremiumMemberIcon, className: styles.premiumIconLabel, color: "red" }),
        React.createElement(Typography, { classNameM: M.of(styles.premiumLabel), variant: HeaderVariants.subHeadTwo, tag: Tags.span },
            React.createElement(React.Fragment, null, Strings.PREMIUM_MEMBER))),
    React.createElement("div", { className: styles.separator }))) : (React.createElement(Link, { href: "/go-premium-web" },
    React.createElement("div", { className: styles.goPremium, onClick: closeDrawer },
        React.createElement("div", { className: cn(styles.premiumButton, isPremiumAccount
                ? styles.premiumIconLbl
                : styles.goPremiumIconLabel), id: "#goPremiumButton" },
            React.createElement(React.Fragment, null,
                React.createElement(Icon, { type: Icons.PremiumIcon, className: isPremiumAccount ? styles.premiumIcon : styles.goPremiumIcon, color: "#fff" }),
                React.createElement(Typography, { classNameM: M.of(styles.label), variant: HeaderVariants.subHeadTwo, tag: Tags.span },
                    React.createElement(React.Fragment, null, Strings.GO_PREMIUM)))))))));

